import React from 'react';
import { useLocation } from 'react-router-dom';
import MobileLayout from './MobileLayout';
import DesktopHeader from './DesktopHeader';
import useMediaQuery from '../hooks/useMediaQuery';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  // Déterminer le titre basé sur la route
  const getTitle = () => {
    const path = location.pathname;
    if (path === '/dashboard') return 'Accueil';
    if (path === '/documents') return 'Archives';
    if (path.startsWith('/documents/add')) return 'Nouvelle Archive';
    if (path.startsWith('/documents/')) return 'Détails';
    if (path === '/parametres') return 'Mon Profil';
    if (path === '/admin/pending-users') return 'Validation Comptes';
    return 'Touba Rennes';
  };

  // Layout mobile/tablette
  if (!isDesktop) {
    return <MobileLayout title={getTitle()}>{children}</MobileLayout>;
  }

  // Desktop layout avec header horizontal
  return (
    <div className="min-h-screen bg-gray-50">
      <DesktopHeader />
      <main className="pt-[65px]">
        <div className="max-w-7xl mx-auto px-6 py-6">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
